import React from 'react';
import { Link } from 'react-router-dom';
import { EntityTypeEnum } from '@api/ringil-api.v2';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import useNavigation from '@hooks/useNavigation';
import { CLICKABLE_TEXT_BASE } from '@components/RingilComponents/clickableText';

interface ComponentProps {
  entityType?: EntityTypeEnum | string;
  entityId?: string;
  /** The expedition's application id — the number on screen, not the uuid. */
  entityLabel?: string;
}

/**
 * The thing a rule acted on, as a link.
 *
 * "The robot assigned a carrier" is only half an answer without "to what", and the id it acted on
 * is meaningless to a reader — so this shows `entityLabel` (FV-004196) and links to the entity.
 * An entity type with no route falls back to the label as plain text rather than a dead link.
 */
const EntityLink: React.FC<ComponentProps> = ({ entityType, entityId, entityLabel }) => {
  const { tr } = useTranslationLgs();
  const nav = useNavigation();

  if (!entityId && !entityLabel) return <span className="text-content-tertiary">—</span>;

  const label = entityLabel ?? tr('AiDispatcher.unlabelledEntity', 'Unnamed');

  if (String(entityType) === String(EntityTypeEnum.EXPEDITION) && entityId) {
    return (
      <Link className={CLICKABLE_TEXT_BASE} to={nav.createNavigationLink(nav.urlFunctions.createExpeditionDetailV2(entityId))}>
        {label}
      </Link>
    );
  }

  return <span>{label}</span>;
};

export default EntityLink;
